<template>
    <img v-if="image.image" :src="image.image" v-b-tooltip.hover :title="image.title" />
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "GearImage",
    props: ["gearId"],
    computed: {
        ...mapState(['gear']),
        image() {
            if(this.gear.length) {
                var gear = this.gear.find(g => g.id === this.gearId)
                var image = gear.image
                if(!image || image === null) {
                    try {
                        image = require('@/assets/gear/'+(gear.brand.toLowerCase()+'-'+gear.title.toLowerCase()).replaceAll(' ', '-')+'.jpg')
                    } catch (e) {
                        image = require('@/assets/img/placeholder.jpg')
                    }
                }

                return {
                    image: image,
                    title: gear.brand+' '+gear.title
                }
            }
            return false
        }
    },
}
</script>